/**
 * Lightweight patient API client.
 * Uses makeRequest for all calls (handles auth headers & token rotation).
 */
import makeRequest from "../makeRequest";

export const patientApi = {
  /** Step 1: lookup patient by MRNO or NIC */
  lookup: (body) => makeRequest({ route: "/patient-auth/lookup", method: "post", data: body }),

  /** Step 2: request OTP */
  requestOtp: (body) => makeRequest({ route: "/patient-auth/request-otp", method: "post", data: body }),

  /** Step 3: verify OTP */
  verifyOtp: (body) => makeRequest({ route: "/patient-auth/verify-otp", method: "post", data: body }),

  /** Password-based login */
  signin: (body) => makeRequest({ route: "/patient-auth/signin", method: "post", data: body }),

  /** Refresh tokens */
  refreshToken: () => makeRequest({ route: "/patient-auth/refresh-token", method: "post" }),

  /** Get current patient */
  me: () => makeRequest({ route: "/patient/me", method: "get" }),

  /** Update profile */
  updateProfile: (body) => makeRequest({ route: "/patient/profile", method: "put", data: body }),

  /** Set / change password */
  setPassword: (body) => makeRequest({ route: "/patient/password", method: "put", data: body }),
  /** Get appointments for logged-in patient */
  getAppointments: ({ mrno, page = 1, limit = 8 }) =>
    makeRequest({ route: `/taleeb/appointments?mrno=${encodeURIComponent(mrno)}&page=${page}&limit=${limit}`, method: "get" }),

  /** Cancel an appointment */
  cancelAppointment: (body) => makeRequest({ route: "/taleeb/cancel-appointment", method: "put", data: body }),

  /** Reschedule an appointment */
  rescheduleAppointment: (body) => makeRequest({ route: "/taleeb/reschedule-appointment", method: "put", data: body }),
  /** Get lab reports for logged-in patient */
  getReports: ({ page = 1, limit = 10 } = {}) => makeRequest({ route: `/patient/reports?page=${page}&limit=${limit}`, method: "get" }),
};
